export const COMPANY_DESCRIPTION_MAX_CHARACTERS = 400;
export const COMPANY_DESCRIPTION_MIN_CHARACTERS = 1;
export const ORGANIZATION_NAME_MAX_LENGTH = 30;
